// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Group catalogue (/overview/products). Builds on overview.css; every
   class here is prefixed gp-. */

.gp-topbar-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.gp-body {
  padding: 28px 0 48px;
}
.gp-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}
.gp-title {
  font-size: 30px;
  line-height: 1.1;
  margin: 0 0 6px;
  color: var(--ov-ink);
  font-weight: 400;
}
.gp-lede {
  margin: 0;
  font-size: 13px;
  color: var(--ov-muted);
  max-width: 640px;
}
.gp-panel {
  background: var(--ov-card);
  border: 1px solid var(--ov-line);
  border-radius: 14px;
  padding: 16px 20px;
}
.gp-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--ov-down);
}

/* toolbar: business tabs + search */
.gp-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--ov-line-soft);
  flex-wrap: wrap;
}
.gp-groups button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.gp-globe {
  font-size: 13px;
  line-height: 1;
  color: var(--ov-teal);
}
.gp-count {
  min-width: 18px;
  padding: 1px 6px;
  border-radius: 20px;
  background: rgba(40, 34, 22, 0.08);
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: var(--ov-body);
}
.ov-segmented button.is-active .gp-count {
  background: var(--ov-gold);
  color: #fff;
}
.gp-search {
  height: 34px;
  width: 260px;
  max-width: 100%;
  padding: 0 12px;
  border: 1px solid var(--ov-line);
  border-radius: 8px;
  background: #fff;
  font: 500 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--ov-ink);
}
.gp-search:focus {
  outline: none;
  border-color: var(--rf-brand-lite);
}

/* selection bar */
.gp-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--ov-line-soft);
  background: var(--ov-canvas);
  min-height: 54px;
  flex-wrap: wrap;
}
.gp-actions.has-selection {
  background: var(--rf-brand-tint, #f6f1e6);
}
.gp-check {
  position: relative;
}
.gp-check .rf-check-label {
  font-size: 12.5px;
  color: var(--ov-body);
}
.gp-readonly {
  font-size: 12px;
  color: var(--ov-muted);
}
.gp-btn-danger {
  border: none;
  background: var(--ov-down);
  color: #fff;
}
.gp-btn-danger:hover:not(:disabled) {
  background: #8f3c33;
}
.gp-btn-danger:disabled,
.ov-btn-primary:disabled {
  opacity: 0.5;
  cursor: default;
}
.gp-confirm {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  color: #7d332b;
}

/* grid of selectable cards */
.gp-empty {
  padding: 48px 20px;
  text-align: center;
  font-size: 13px;
  color: var(--ov-muted);
}
.gp-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 14px;
  padding: 18px 20px 22px;
}
.gp-item {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: box-shadow 160ms, border-color 160ms, transform 160ms;
}
.gp-item:hover {
  border-color: #d8cfb8;
  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.11);
  transform: translateY(-2px);
}
.gp-item.is-on {
  border-color: var(--ov-gold);
  box-shadow: 0 0 0 2px rgba(143, 113, 54, 0.22);
}
.gp-item input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.gp-tick {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 1.5px solid #ddd7cb;
  background: rgba(255, 255, 255, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: transparent;
}
.gp-item.is-on .gp-tick {
  background: var(--ov-gold);
  border-color: var(--ov-gold);
  color: #fff;
}
.gp-item input:focus-visible ~ .gp-tick {
  border-color: var(--rf-brand-lite);
}
.gp-thumb {
  position: relative;
  aspect-ratio: 4 / 3;
  background: #f4f1ea center / cover no-repeat;
  border-bottom: 1px solid #f0ece3;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d3cbb8;
  font-size: 40px;
  flex-shrink: 0;
}
.gp-code {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 2px 7px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #e2dcd0;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #4a453c;
  font-variant-numeric: tabular-nums;
}
.gp-item-body {
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.gp-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--ov-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gp-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
}
.gp-tag {
  color: var(--ov-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gp-owner {
  flex-shrink: 0;
  padding: 1px 7px;
  border-radius: 20px;
  background: #eef3f2;
  color: var(--ov-teal);
  font-weight: 600;
  white-space: nowrap;
}

/* the rf-check pattern is defined in new-order.css, which this page does
   not load; the rules it needs are repeated here. */
.rf-check {
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.rf-check input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.rf-check-box {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  border: 1.5px solid #ddd7cb;
  border-radius: 5px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: transparent;
}
.rf-check input:checked + .rf-check-box {
  background: var(--ov-gold);
  border-color: var(--ov-gold);
  color: #fff;
}
.rf-check input:disabled + .rf-check-box {
  opacity: 0.5;
}
.rf-check-label {
  font: 600 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}

@media (max-width: 900px) {
  .ov-body.gp-body {
    width: 94%;
  }
  .gp-search {
    width: 100%;
  }
}

/* funeral director cards (no image; contact lines + commission) */
.gp-grid-fd {
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}
.gp-item-body.gp-fd {
  padding: 14px 14px 12px;
  gap: 10px;
  padding-right: 40px; /* room for the tick */
}
.gp-fd-top {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.gp-fd-mark {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--ov-line-soft);
  color: var(--ov-body);
  font: 700 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  letter-spacing: 0.04em;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gp-fd-title {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.gp-fd-lines {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: var(--ov-body);
  min-height: 34px;
}
.gp-fd-lines > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gp-fd-addr {
  color: var(--ov-muted);
}
.gp-fd-pct {
  font-weight: 600;
  color: var(--ov-up);
  font-variant-numeric: tabular-nums;
}
.gp-fd-pct.is-zero {
  color: var(--ov-muted-2);
  font-weight: 500;
}
.gp-fd-title .gp-tag {
  font-size: 11.5px;
}
`, "",{"version":3,"sources":["webpack://./src/group-products.css"],"names":[],"mappings":"AAAA;gCACgC;;AAEhC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gEAAgE;EAChE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iEAAiE;AACnE;AACA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;oDACoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,8DAA8D;EAC9D,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA,kEAAkE;AAClE;EACE,4DAA4D;AAC9D;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,mBAAmB,EAAE,sBAAsB;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,8DAA8D;EAC9D,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["/* Group catalogue (/overview/products). Builds on overview.css; every\n   class here is prefixed gp-. */\n\n.gp-topbar-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.gp-body {\n  padding: 28px 0 48px;\n}\n.gp-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n}\n.gp-title {\n  font-size: 30px;\n  line-height: 1.1;\n  margin: 0 0 6px;\n  color: var(--ov-ink);\n  font-weight: 400;\n}\n.gp-lede {\n  margin: 0;\n  font-size: 13px;\n  color: var(--ov-muted);\n  max-width: 640px;\n}\n.gp-panel {\n  background: var(--ov-card);\n  border: 1px solid var(--ov-line);\n  border-radius: 14px;\n  padding: 16px 20px;\n}\n.gp-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--ov-down);\n}\n\n/* toolbar: business tabs + search */\n.gp-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid var(--ov-line-soft);\n  flex-wrap: wrap;\n}\n.gp-groups button {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.gp-globe {\n  font-size: 13px;\n  line-height: 1;\n  color: var(--ov-teal);\n}\n.gp-count {\n  min-width: 18px;\n  padding: 1px 6px;\n  border-radius: 20px;\n  background: rgba(40, 34, 22, 0.08);\n  font-size: 11px;\n  font-variant-numeric: tabular-nums;\n  color: var(--ov-body);\n}\n.ov-segmented button.is-active .gp-count {\n  background: var(--ov-gold);\n  color: #fff;\n}\n.gp-search {\n  height: 34px;\n  width: 260px;\n  max-width: 100%;\n  padding: 0 12px;\n  border: 1px solid var(--ov-line);\n  border-radius: 8px;\n  background: #fff;\n  font: 500 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--ov-ink);\n}\n.gp-search:focus {\n  outline: none;\n  border-color: var(--rf-brand-lite);\n}\n\n/* selection bar */\n.gp-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n  border-bottom: 1px solid var(--ov-line-soft);\n  background: var(--ov-canvas);\n  min-height: 54px;\n  flex-wrap: wrap;\n}\n.gp-actions.has-selection {\n  background: var(--rf-brand-tint, #f6f1e6);\n}\n.gp-check {\n  position: relative;\n}\n.gp-check .rf-check-label {\n  font-size: 12.5px;\n  color: var(--ov-body);\n}\n.gp-readonly {\n  font-size: 12px;\n  color: var(--ov-muted);\n}\n.gp-btn-danger {\n  border: none;\n  background: var(--ov-down);\n  color: #fff;\n}\n.gp-btn-danger:hover:not(:disabled) {\n  background: #8f3c33;\n}\n.gp-btn-danger:disabled,\n.ov-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.gp-confirm {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  color: #7d332b;\n}\n\n/* grid of selectable cards */\n.gp-empty {\n  padding: 48px 20px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--ov-muted);\n}\n.gp-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: 14px;\n  padding: 18px 20px 22px;\n}\n.gp-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  user-select: none;\n  transition: box-shadow 160ms, border-color 160ms, transform 160ms;\n}\n.gp-item:hover {\n  border-color: #d8cfb8;\n  box-shadow: 0 10px 26px rgba(40, 34, 22, 0.11);\n  transform: translateY(-2px);\n}\n.gp-item.is-on {\n  border-color: var(--ov-gold);\n  box-shadow: 0 0 0 2px rgba(143, 113, 54, 0.22);\n}\n.gp-item input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.gp-tick {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  border: 1.5px solid #ddd7cb;\n  background: rgba(255, 255, 255, 0.94);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: transparent;\n}\n.gp-item.is-on .gp-tick {\n  background: var(--ov-gold);\n  border-color: var(--ov-gold);\n  color: #fff;\n}\n.gp-item input:focus-visible ~ .gp-tick {\n  border-color: var(--rf-brand-lite);\n}\n.gp-thumb {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  background: #f4f1ea center / cover no-repeat;\n  border-bottom: 1px solid #f0ece3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d3cbb8;\n  font-size: 40px;\n  flex-shrink: 0;\n}\n.gp-code {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  padding: 2px 7px;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.94);\n  border: 1px solid #e2dcd0;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #4a453c;\n  font-variant-numeric: tabular-nums;\n}\n.gp-item-body {\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.gp-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--ov-ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gp-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 11px;\n}\n.gp-tag {\n  color: var(--ov-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gp-owner {\n  flex-shrink: 0;\n  padding: 1px 7px;\n  border-radius: 20px;\n  background: #eef3f2;\n  color: var(--ov-teal);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* the rf-check pattern is defined in new-order.css, which this page does\n   not load; the rules it needs are repeated here. */\n.rf-check {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  cursor: pointer;\n  user-select: none;\n}\n.rf-check input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.rf-check-box {\n  width: 17px;\n  height: 17px;\n  flex-shrink: 0;\n  border: 1.5px solid #ddd7cb;\n  border-radius: 5px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: transparent;\n}\n.rf-check input:checked + .rf-check-box {\n  background: var(--ov-gold);\n  border-color: var(--ov-gold);\n  color: #fff;\n}\n.rf-check input:disabled + .rf-check-box {\n  opacity: 0.5;\n}\n.rf-check-label {\n  font: 600 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n\n@media (max-width: 900px) {\n  .ov-body.gp-body {\n    width: 94%;\n  }\n  .gp-search {\n    width: 100%;\n  }\n}\n\n/* funeral director cards (no image; contact lines + commission) */\n.gp-grid-fd {\n  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));\n}\n.gp-item-body.gp-fd {\n  padding: 14px 14px 12px;\n  gap: 10px;\n  padding-right: 40px; /* room for the tick */\n}\n.gp-fd-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n.gp-fd-mark {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--ov-line-soft);\n  color: var(--ov-body);\n  font: 700 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  letter-spacing: 0.04em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.gp-fd-title {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.gp-fd-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 12px;\n  color: var(--ov-body);\n  min-height: 34px;\n}\n.gp-fd-lines > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gp-fd-addr {\n  color: var(--ov-muted);\n}\n.gp-fd-pct {\n  font-weight: 600;\n  color: var(--ov-up);\n  font-variant-numeric: tabular-nums;\n}\n.gp-fd-pct.is-zero {\n  color: var(--ov-muted-2);\n  font-weight: 500;\n}\n.gp-fd-title .gp-tag {\n  font-size: 11.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
